export const PHONE_BRAND_LOAD = 'PHONE_BRAND_LOAD';
export const PHONE_BRAND_LOADED = 'PHONE_BRAND_LOADED';
export const PHONE_BRAND_ALL_LOAD = 'PHONE_BRAND_ALL_LOAD';
export const PHONE_BRAND_ALL_LOADED = 'PHONE_BRAND_ALL_LOADED';
export const PHONE_BRAND_IMAGE_UPLOAD = 'PHONE_BRAND_IMAGE_UPLOAD';
export const PHONE_BRAND_SEARCH = 'PHONE_BRAND_SEARCH';
export const PHONE_BRAND_UNLOADED = 'PHONE_BRAND_UNLOADED';
export const PHONE_BRAND_UPDATE = 'PHONE_BRAND_UPDATE';
export const PHONE_BRAND_CREATE = 'PHONE_BRAND_CREATE';
export const PHONE_BRAND_CREATE_UPDATE_SUCCESS = 'PHONE_BRAND_CREATE_UPDATE_SUCCESS';